// **  Initial State
const initialState = {
  isAppLoaded: false,
  userData: null,
}

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'INIT_APP':
      return {
        ...state,
        isAppLoaded: true,
        userData: { ...action.data }
      }
    case 'UPDATE_PROFILE':
      return {
        ...state,
        userData: { ...action.data }
      }
    case 'LOGOUT':
      return { ...state, userData: null }
    // case 'LOGOUT':
    //   const obj = { ...action }
    //   delete obj.type
    //   return { ...state, userData: {}, ...obj }
    default:
      return state
  }
}

export default authReducer
